{
  "title": "オークションを見る",
  "resultsCount": "{count} 件の出品",
  "noResults": "条件に一致するオークションはありません。",
  "noneYet": "表示できる出品はまだありません。",
  "noneInCategory": "このカテゴリーに開催中のオークションはまだありません。",
  "searchPlaceholder": "カード、フィギュア、ファッションなどを検索…",
  "sortBy": "並び替え",
  "sort": {
    "endingSoon": "終了が近い順",
    "newest": "新着順",
    "priceLow": "価格の安い順",
    "priceHigh": "価格の高い順"
  },
  "filters": {
    "category": "カテゴリー",
    "condition": "状態",
    "grader": "鑑定会社",
    "grade": "グレード",
    "priceRange": "価格帯",
    "productType": "商品タイプ",
    "clearAll": "絞り込みをすべて解除"
  },
  "card": {
    "viewLot": "出品を見る",
    "watch": "ウォッチリストに追加",
    "unwatch": "ウォッチリストから削除",
    "featured": "注目",
    "graded": "{company} 鑑定済み",
    "certNumber": "鑑定番号",
    "notVerified": "第三者による確認は取れていません",
    "currentBid": "現在の入札額",
    "starting": "開始価格",
    "buyNow": "即決購入",
    "qty": "数量 {count}",
    "autographed": "直筆サイン入り",
    "other": "その他"
  },
  "card360": {
    "heading": "360°コンディションビュー",
    "badge": "出品者撮影・無加工",
    "sets": {
      "front_rotation": "表面",
      "back_rotation": "裏面",
      "edge_inspection": "エッジ",
      "corner_inspection": "コーナー",
      "surface_inspection": "表面状態"
    },
    "captureSets": {
      "front_rotation": "表面の回転",
      "back_rotation": "裏面の回転",
      "edge_inspection": "エッジ",
      "corner_inspection": "コーナー",
      "surface_inspection": "表面状態"
    },
    "hints": {
      "front_rotation": "1枚ごとにカードを少しずつ回転させ、表面を一周させてください。",
      "back_rotation": "裏面も同様に。センタリングや印刷ラインの判断に使われます。",
      "edge_inspection": "各エッジのクローズアップ。白欠けや欠けは正直に写してください。",
      "corner_inspection": "各コーナーを1枚ずつ、ピントと明るさを確保して撮影。",
      "surface_inspection": "光を斜めに当て、キズ・凹み・印刷不良が分かる角度で撮影。"
    },
    "issues": {
      "blurred": "ぼやけています",
      "too_dark": "暗すぎます",
      "overexposed": "白飛び・反射",
      "dimension_mismatch": "他と寸法が異なります",
      "orientation_mismatch": "向きが異なります",
      "duplicate": "直前のフレームとほぼ同一",
      "too_large": "8MB超",
      "corrupt": "読み込めないファイル",
      "bad_type": "非対応の形式"
    },
    "viewer": {
      "regionLabel": "360度コンディションビュー",
      "groupLabel": "{title} — 360度ビュー、{count}枚中{index}枚目",
      "frameAlt": "{title} — 360°フレーム {count}枚中{index}枚目",
      "loading": "読み込み中 {loaded} / {count} フレーム",
      "dragToRotate": "ドラッグで回転",
      "play": "回転を再生",
      "pause": "回転を一時停止",
      "zoomIn": "拡大",
      "zoomOut": "縮小",
      "fullscreen": "360°ビューを全画面で開く",
      "closeFullscreen": "全画面を閉じる",
      "fullscreenTitle": "{title} — 360°コンディションビュー",
      "failed": "360°フレームを読み込めませんでした。接続を確認して再度お試しください。"
    },
    "capture": {
      "toggleLabel": "360°コンディションビューを有効にする",
      "description": "未鑑定の生カードで利用できます。入札前にカードを回転させ、コーナー・エッジ・表面を確認できるため、成約率が大きく向上します。",
      "guided": "ガイド付き撮影",
      "upload": "連続写真をアップロード",
      "clear": "セットをクリア",
      "progress": "{count} / {target} フレーム",
      "minimum": "（最低 {min}）",
      "toReview": "要確認 {count} 件",
      "blocking": "使用できないフレームがあります — 出品前に削除してください。",
      "unreadable": "読み込み不可",
      "integrity": "フレームは撮影したまま保存されます。フィルター・レタッチ・AI補正はセラー規約違反です。",
      "frameAlt": "{label} フレーム {index}",
      "removeFrame": "フレーム {index} を削除",
      "cameraUnavailable": "カメラを利用できません — 写真シーケンスをアップロードしてください。",
      "cameraPreview": "カメラプレビュー",
      "frameOf": "フレーム {index} / {target} · 約 {angle}° まで回転",
      "captureFrame": "フレームを撮影",
      "done": "完了",
      "closeCapture": "撮影を閉じる"
    }
  }
}
